<template>
  <div>
    <md-field :class="getValidationClass('potenciaMotor')">
      <label for="potenciaMotor">Potência do Motor (cv)</label>
      <md-input
        v-model.number="motoBomba.potenciaMotor"
        type="number"
        @change="handleChange"
      />
      <span v-if="!$v.motoBomba.potenciaMotor.required" class="md-error"
        >Potência do Motor é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('marcaDoConjuntoMotoBomba')">
      <label for="marcaDoConjuntoMotoBomba">Marca do Conjunto Moto-Bomba</label>
      <md-input
        v-model.trim="motoBomba.marcaDoConjuntoMotoBomba"
        @change="handleChange"
      />
      <span
        v-if="!$v.motoBomba.marcaDoConjuntoMotoBomba.required"
        class="md-error"
        >Conjunto Moto-Bomba é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('modeloDoConjuntoMotoBomba')">
      <label for="modeloDoConjuntoMotoBomba"
        >Modelo do Conjunto Moto-Bomba</label
      >
      <md-input
        v-model="motoBomba.modeloDoConjuntoMotoBomba"
        @change="handleChange"
      />
      <span
        v-if="!$v.motoBomba.modeloDoConjuntoMotoBomba.required"
        class="md-error"
        >Modelo do Conjunto Moto-Bomba é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('tipoDeBomba')">
      <label for="tipoDeBomba">Tipo de Bomba</label>
      <md-select
        id="localInstalacao"
        v-model="motoBomba.tipoDeBomba"
        name="localInstalacao"
        @md-selected="handleChange"
      >
        <md-option value="Poço"> Poço </md-option>
        <md-option value="Pressurizadora"> Pressurizadora </md-option>
        <md-option value="Outro"> Outro </md-option>
      </md-select>
      <span v-if="!$v.motoBomba.tipoDeBomba.required" class="md-error"
        >Tipo de Bomba é obrigatório</span
      >
    </md-field>

    <md-field v-if="motoBomba.tipoDeBomba === 'Outro'">
      <label for="tipoDeBombaOutro">Especificar o Tipo da Bomba</label>
      <md-input v-model="motoBomba.tipoDeBombaOutro" @change="handleChange" />
    </md-field>

    <div style="text-align: left">
      <label for="dataDaUltimaManutencao">Data da Última Manutenção</label>
    </div>
    <md-datepicker
      v-model="motoBomba.dataDaUltimaManutencao"
      @change="handleChange"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FormularioMotoBombaSig',
  mixins: [validationMixin],
  props: {
    data: Object,
  },
  data() {
    return {
      motoBomba: {
        potenciaMotor: null,
        marcaDoConjuntoMotoBomba: null,
        modeloDoConjuntoMotoBomba: null,
        tipoDeBomba: 'Poço',
        tipoDeBombaOutro: null,
        dataDaUltimaManutencao: new Date(),
      },
    }
  },
  validations: {
    motoBomba: {
      potenciaMotor: { required },
      marcaDoConjuntoMotoBomba: { required },
      modeloDoConjuntoMotoBomba: { required },
      tipoDeBomba: { required },
      tipoDeBombaOutro: { required },
      dataDaUltimaManutencao: { required },
    },
  },
  beforeMount() {
    if (this.data) {
      this.motoBomba = { ...this.data }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.motoBomba[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    handleChange() {
      this.$v.$touch()

      this.$forceUpdate()

      this.$emit('change', {
        isValid: !this.$v.$invalid,
        data: { ...this.motoBomba },
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
